module.exports = __webpack_public_path__ + "assets/smart-asset-clock.9cdbe920.svg";